import { RowDataStoreItem } from "../../components/StoreItemPage/types";
import DataDisplayRowI from "../DataDisplayRowI";

/**
 * This class should be intialized with the StoreItemTable factory
 */
class StoreItemRow implements DataDisplayRowI {
    endpoint: string;
    accessData: string;

    constructor() {
        this.endpoint = "/api/admin/items/read-range"
        this.accessData = "items"
    }

    create(item: any): RowDataStoreItem {
        const rowDataOrder: RowDataStoreItem = {

            id: item.id,
            displayName: item.displayName,
            itemName: item.itemName,
            altItemLookup: item.altItemLookup,
            xItemId: item.xItemId,
            xItemCode: item.xItemCode, 
            xItemType: item.xItemType, 
            xItemModel: item.xItemModel, 
            xDivision: item.xDivision, 
            brand: item.brand,
            xCategory: item.xCategory, 
            cost: item.cost,
            priceScheme: item.priceScheme ? JSON.parse(item.priceScheme) : null,

            description: item.description, 
            images: item.images,
            show: item.show, 
            isReady: item.isReady,
            deleted: item.deleted,
            createdAt: item.createdAt, 
            updatedAt: item.updatedAt,
            category: item.category,

            isNewArrival: item.isNewArrival,
            isHotDeals: item.isHotDeals,

            action: "",
        };
        return rowDataOrder;
    }

    generateParams(params: any, extra: any) {
        params["new"] = extra.current
        return params
    }
}

let storeItemRow: StoreItemRow | null = null;

export default function getStoreItemRow(): StoreItemRow {
    if (storeItemRow === null)
        storeItemRow = new StoreItemRow()
    return storeItemRow
}